import { gql } from "lib/apolloClient";

export const courseItemFragment = gql`
  fragment courseItem on LearningCourse {
    id
    title
    state
    isBookmarked
    type
    subjects {
      id
      name
    }
    grades(filters: $gradeFilters) {
      id
      name
    }
    classes(filters: $classesFilters) {
      id
      title
    }
    displayMetadata
  }
`;

export const courseItemFragmentV2 = gql`
  fragment courseItem on LearningCourse {
    id
    title
    state
    isBookmarked
    type
    subjects {
      id
      name
      subjectGroup {
        id
        name
      }
    }
    grades(filters: $gradeFilters) {
      id
      name
    }
    subjectGroup {
      id
      name
    }
    associatedLevels {
      id
      abbreviation
    }
    subjectLevelMap {
      associatedLevels {
        id
        abbreviation
      }
    }
    gradingPeriods(filters: $termFilters) {
      edges {
        node {
          id
          label
        }
      }
    }
    classes(filters: $classesFilters) {
      id
      title
      profileImageData {
        url
        icon
        color
        acronym
      }
    }
    childCourses {
      id
      title
    }
    displayMetadata
    academicCourse {
      code
    }
    curriculumProgram {
      id
      label
    }
  }
`;

export const classItemFragment = gql`
  fragment classItem on Course {
    id
    title
    isArchived
    isBookmark
    learningCourse {
      id
      title
      displayMetadata
    }
    profileImageData {
      icon
      color
      acronym
    }
  }
`;

export const courseBookmarkStatusFragment = gql`
  fragment courseBookmarkStatus on LearningCourse {
    id
    isBookmarked
  }
`;

export const classBookmarkStatusFragment = gql`
  fragment classBookmarkStatus on Course {
    id
    isBookmark
  }
`;
